import type { InteractionEvent } from '../types/craft';
import { EXTERNAL_LINK_EVENT, LINK_TO_PAGE_EVENT, OPEN_POPUP_EVENT } from './constants';

//helper functions for the button component

export function getHrefAttr(clickEvent: InteractionEvent) {
  return clickEvent.eventData?.url || undefined;
}

export function getPopupTargetAttr(clickEvent: InteractionEvent) {
  if (clickEvent.eventType === OPEN_POPUP_EVENT) {
    return clickEvent.eventData?.optionId || undefined;
  }
  return undefined;
}

export function getTargetAttr(clickEvent: InteractionEvent) {
  if (clickEvent.eventType === EXTERNAL_LINK_EVENT || clickEvent.eventType === LINK_TO_PAGE_EVENT) {
    return clickEvent.eventData?.newTab ? '_blank' : '_top';
  }
  return '_top';
}

export function getRelHrefAttr(clickEvent: InteractionEvent) {
  let rel = 'noopener noreferrer';
  if (clickEvent.eventType === EXTERNAL_LINK_EVENT || clickEvent.eventType === LINK_TO_PAGE_EVENT) {
    if (clickEvent.eventData?.useNofollow) {
      rel = 'nofollow noopener noreferrer';
    }
  }
  return rel;
}
